import { z } from 'zod';

/** RHF may include empty placeholder rows; empty names are stripped in submit / transform */
const subItemSchema = z.object({
    name: z.string().optional(),
    description: z.string().optional()
});

export const ContextSchema = z.object({
    id: z.union([z.string(), z.number()]).optional(),
    name: z.string().min(1, "form.validation.nameRequired"),
    description: z.string().min(1, "form.validation.descriptionRequired"),
    type: z.string().optional(),
    /** Form-only; mapped to `type` before API create/update */
    isInternal: z.boolean().optional(),
    status: z.string().default('active'),
    subItems: z.array(subItemSchema).optional().default([]),
    organizationalPurpose: z.string().optional(),
    intendedOutcomes: z.string().optional(),
    customFields: z.record(z.unknown()).optional(),
    createdAt: z.union([z.string(), z.date()]).optional(),
    updatedAt: z.union([z.string(), z.date()]).optional(),
});
const _createBase = ContextSchema.omit({
    id: true,
    createdAt: true,
    updatedAt: true,
    isInternal: true
});

function stripEmptySubItems(data) {
    if (!data || !Array.isArray(data.subItems)) return data;
    return {
        ...data,
        subItems: data.subItems
            .filter((s) => s && String(s.name || '').trim().length > 0)
            .map((s) => ({
                name: String(s.name).trim(),
                description: s.description != null ? String(s.description) : ''
            }))
    };
}

export const CreateContextSchema = _createBase.transform(stripEmptySubItems);
export const UpdateContextSchema = _createBase.partial().transform(stripEmptySubItems);
export const contextFormSchema = ContextSchema;
export const ContextFormSchema = contextFormSchema;
